<script>
export default {
  name: 'SidebarMenuItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    imagePath() {
      const img = this.item.route === this.$route.name ? this.item.iconActive : this.item.icon;
      return 'img/' + img;
    }
  },
  methods: {
    changeRoute() {
      if (this.$helper.isMobile()) {
        this.$store.dispatch('common/closeSidebar');
      }
    }
  }
};
</script>

<template lang="pug">
  li(v-if='item.active === true')
    router-link.menu-item(
      :to="{name: item.route}"
      :class="{active: item.route === $route.name}"
      @click.native="changeRoute"
    )
      .bb.menu-content
        img(
          :src="imagePath"
        )
        span {{item.name}}
</template>

<style lang="scss" scoped>
</style>
